module.exports = __webpack_public_path__ + "img/father.8021b7e8.png";